const BADGE_CLASSES: Record<string, string> = {
  active: 'badge-active',
  renewing: 'badge-renewing',
  canceling: 'badge-canceling',
  cancelled: 'badge-canceling',
  expired: 'badge-expired',
  joined: 'badge-joined',
  left: 'badge-left',
  unknown: 'badge-joined',
  // payment states
  CREATED: 'badge-joined',
  AWAITING_PAYMENT: 'badge-expired',
  PAYMENT_DETECTED: 'badge-renewing',
  CONFIRMING: 'badge-renewing',
  SWEEPING: 'badge-renewing',
  COMPLETED: 'badge-active',
  EXPIRED: 'badge-expired',
  FAILED: 'badge-canceling',
  UNDERPAID: 'badge-canceling',
  REFUNDING: 'badge-renewing',
};

export function Badge({ status, label }: { status: string; label?: string }) {
  const cls = BADGE_CLASSES[status] ?? 'badge-joined';
  return <span className={`badge ${cls}`}>{label ?? status}</span>;
}
